// Numbers, money and times the way the console writes them: French first
// (13 500 XAF, 0,5 kg, with a no-break space between thousands), Yaoundé time.
export const TZ = 'Africa/Douala';

const nf = new Intl.NumberFormat('fr-FR');
// Intl puts a narrow no-break space between thousands; print a plain no-break
// space instead, so an amount never splits across lines and renders in every font.
const thin = (s: string) => s.replace(/[\u202f\u00a0]/g, '\u00a0');

export const fmtN = (n: number) => thin(nf.format(n));
export const xaf = (n: number) => thin(nf.format(Math.round(n))) + ' XAF';
export const dec1 = (n: number) => n.toFixed(1).replace('.', ',');

export function hhmm(d: Date | string | number) {
  return new Date(d).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: TZ });
}

export function dayLabel(d: Date | string, opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short' }) {
  return new Date(d).toLocaleDateString('fr-FR', { ...opts, timeZone: TZ }).replace('.', '');
}

/** Minutes between two instants, never below zero. */
export const minutesBetween = (a: Date | string | number, b: Date | string | number = Date.now()) =>
  Math.max(0, (new Date(b).getTime() - new Date(a).getTime()) / 60000);

export function rel(min: number, lang: 'fr' | 'en' = 'fr') {
  if (lang === 'en') {
    if (min < 1) return 'just now';
    if (min < 60) return Math.round(min) + ' min ago';
    const h = Math.round(min / 60);
    return h < 48 ? h + ' h ago' : Math.round(h / 24) + ' d ago';
  }
  if (min < 1) return "à l'instant";
  if (min < 60) return 'il y a ' + Math.round(min) + ' min';
  const h = Math.round(min / 60);
  return h < 48 ? 'il y a ' + h + ' h' : 'il y a ' + Math.round(h / 24) + ' j';
}

/** Two initials for an avatar disc. */
export const initials = (name: string) =>
  name.split(/[\s-]+/).filter(Boolean).map((w) => w[0]).join('').slice(0, 2).toUpperCase();

// The prototype's avatar colours, picked from the name so a person keeps theirs.
const DISC = ['#0E74BC', '#6A5ACD', '#E0672E', '#16A34A', '#C42B2B', '#0B5C96', '#9A5800', '#5444B5', '#137A3A', '#334155'];
export function discColor(key: string) {
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return DISC[h % DISC.length];
}

/** Smallest tidy axis that holds v with at most maxT steps (the prototype's niceScale). */
export function niceScale(v: number, maxT = 5) {
  v = Math.max(v, 1);
  for (const k of [0, 1, 2, 3, 4, 5, 6, 7]) {
    const p = Math.pow(10, k);
    for (const m of [1, 2, 2.5, 5]) {
      if (!k && m === 2.5) continue;
      const st = m * p;
      if (Math.ceil(v / st) <= maxT) {
        const n = Math.ceil(v / st);
        return { mx: n * st, ticks: Array.from({ length: n + 1 }, (_, i) => i * st) };
      }
    }
  }
  return { mx: v, ticks: [0, v] };
}
